<template>
<div class="chapter">
<div class="inner_page">
<div class="photograph sourcesPage" id="Photograph_Sources">
<div class="chapterHead" id="chapter">
<h2 class="chapterTitle1"><a id="page_ix"></a>Photograph Sources</h2>
</div>
<p class="paraNoIndent"><span class="dropcap">T</span>his book would not have been possible without the able assistance of the Stavka Photo Library run by Eastern Front expert Nik Cornish, who has written and illustrated a number of Eastern Front titles in this Images of War series, and the private Eastern Front collection of Canadian Scott Pick. These two men have built up collections that are unrivalled outside of museum holdings. Both have a fascinating range of images taken by both official war photographers and individual soldiers, depicting the many aspects of the conflict between Nazi Germany and Soviet Russia, many of them previously unpublished.</p>
<p class="para">In particular, many of the Scott Pick images are seeing the public light of day for the very first time and I offer thanks to him for agreeing to share them with us. His collection contains many fine ‘trophy’ shots, such as those taken by individual German soldiers of their comrades standing triumphantly on top of disabled Soviet armour in the early stages of the war. As readers will see, the clarity of these is outstanding and each tells its own particular and sometimes gruesome story.</p>
<p class="para">Lastly I have also drawn some images from my own collection, which derives from a variety of sources, and again many of these are being published for the very first time. Picture editing is a very subjective art and the final selection in this book rests with me – I hope that readers enjoy them.</p>
<p class="paraBold">Photo Credits</p>
<p class="paraNoIndent">The following photographs are courtesy of the Museum of the Armed Forces, Moscow, via Nik Cornish: AO36, AO38, AO41, AO42, AO44, AO45, AO46, AO47, AO48, AO120, AO146, AO153, B84, B89, BA3, BA24, BA51, BA52, BA55, K10, K14, K180, K184, K191, K194 and T49.</p>
<p class="para">The following are from the Russian State Documentary Film and Photo Archive (RGAKFD) in Krasnogorsk, again via Nik Cornish: A44, A46, B19, B21, B25, B26, BA18, BA28, BA211, K5, K6, K9, K17, K22, K25, K78, K174, K175 and L32.</p>
<p class="para">All images with a WH reference number and RA 31 are credited to Nik Cornish at Stavka.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Photograph_Sources.vue?707910e4